import * as React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const AddRowBeforeMenuItem = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().addRowBefore().run()}
         icon={<FontAwesomeIcon icon={faArrowUp} size="lg" />}
         title={_js('Add row above')}
         isDisabled={!editor.can().addRowBefore()}
         iconSpacing={0}
      />
   );
};
